module.exports = __webpack_public_path__ + "static/media/exedra_big.26548f62.svg";